import { type Ref, ref, shallowRef } from 'vue'
import { defineStore } from 'pinia'
import logoEverDesk from '@/assets/images/everdesk-logo.svg'
import { getLogoInstance } from '@/common/services/AppearancesService'

export const useApplicationStore = defineStore('application', () => {
  const ready: Ref<boolean> = ref(false)
  const legacyFrame = shallowRef<HTMLIFrameElement | undefined>()
  const active: Ref<boolean> = ref(true)
  const disabled: Ref<boolean> = ref(false)
  const logo: Ref<string> = ref('')
  const engage: Ref<boolean> = ref(false)
  const modalOpened: Ref<boolean> = ref(false)

  const getLogo = async () => {
    try {
      logo.value = await getLogoInstance()
    } catch {
      logo.value = logoEverDesk
      console.log('Unable to retrieve instance logo')
    }
  }

  return {
    ready,
    legacyFrame,
    active,
    disabled,
    logo,
    getLogo,
    engage,
    modalOpened,
  }
})
